export default __webpack_public_path__ + "assets/98685f28fca22d4abbac3fa9a8b797fb.jpeg";